/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';
import type { ColumnDef } from '@tanstack/react-table';

import type { DescribeImageInstance } from '@/api/generated.schemas';
import { ColumnHeader } from '@/components/blocks/data-table/column-header';
import { Preview } from '@/components/blocks/preview/preview';

type Instance = DescribeImageInstance;

export const columns: Array<ColumnDef<Instance>> = [
  {
    accessorKey: 'index',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.details.index')}
        />
      );
    },
    cell: ({ row }) => row.original.index + 1,
  },
  {
    accessorKey: 'input',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.details.input')}
        />
      );
    },
    cell: ({ row }) => {
      if (!row.original.input.path) return null;
      return (
        <Preview
          id={row.original.input.id}
          options={{
            path: row.original.input.path,
            mutationKey: row.original.input.id,
          }}
        />
      );
    },
  },
  {
    accessorKey: 'reference',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.details.reference')}
        />
      );
    },
    cell: ({ row }) => {
      if (!row.original.reference?.path) return null;
      return (
        <Preview
          id={row.original.reference.id}
          options={{
            path: row.original.reference.path,
            mutationKey: row.original.reference.id,
          }}
        />
      );
    },
  },
  {
    accessorKey: 'targetLanguage',
    header: ({ column }) => {
      const { t } = useTranslation();
      return (
        <ColumnHeader
          column={column}
          title={t('datasets.details.targetLanguage')}
          enableSorting
        />
      );
    },
  },
];
